// extracted by mini-css-extract-plugin
module.exports = {"animate":"ListRows_animate__1lsZi"};